// extracted by mini-css-extract-plugin
export var pillWrapper = "_pe-0";
export var showOverflow = "_pe-1";